import { render } from "./portal-get-started.vue?vue&type=template&id=3a877a3c&scoped=true"
import script from "./portal-get-started.vue?vue&type=script&lang=js"
export * from "./portal-get-started.vue?vue&type=script&lang=js"

import "./portal-get-started.vue?vue&type=style&index=0&id=3a877a3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a877a3c"]])

export default __exports__